import React, { useCallback, useState } from "react";
import EvidenceUploader from "./components/EvidenceUploader.jsx";
import EvidenceList from "./components/EvidenceList.jsx";
import EvidenceAssociations from "./components/EvidenceAssociations";

export default function RiskEvidence({ riskId }) {
  const [reloadKey, setReloadKey] = useState(0);

  const handleCreated = useCallback(() => {
    setReloadKey((k) => k + 1);
  }, []);

  return (
    <div className="risk-evidence">
      <EvidenceUploader parentType="risk" parentId={riskId} onCreated={handleCreated} />
      <EvidenceList key={reloadKey} parentType="risk" parentId={riskId} />
      <EvidenceAssociations parentType="risk" parentId={riskId} />
    </div>
  );
}
